import BasicRouterView from "../../../components/BasicRouterView.vue";

const fiscalRouter = {
  path: "fsc",
  redirect: { name: "fiscal-listagem" },
  meta: {
    label: "Fiscal",
    icon: "pinch",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "fiscal/listagem-estoque",
      name: "fiscal-listagem",
      meta: {
        label: "Estoque atual",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ListagemEstoque.vue"),
    },
  ],
};

export default fiscalRouter;
